import { Inject, Injectable } from '@angular/core';
import { externalLoginProvider } from '../enums';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SettingsService } from './settings.service';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ExternalLoginService {

  private environment: {[key: string]: string};


  constructor(
    private http: HttpClient,
    private settings: SettingsService,
    private storageService: StorageService,
    private router: Router,

    @Inject('environment')
    environment: {[key: string]: string}
  ) { }

  loginToProvider(provider: externalLoginProvider) {
    switch(provider) {
      case externalLoginProvider.SFC:
        this.handleSFCLogin();
        break;
      case externalLoginProvider.IDACTOR:
        this.handleIdactorLogin();
        break;
    }
    
  }

  private handleSFCLogin() {
    // Implement SFC login logic here
   
    console.log("Logging in with SFC");
    //let url = "https://tunnistus.avoine.fi/sso-login/?service=hotellinx-sfc&return=http://localhost:5074/api/auth/sso/avoine/callback?frontendUrl=https://localhost:4200";
    
    let endpoint = this.settings.getEndpoint();

    const url = `${endpoint}/auth/sso/avoine/init`;

    this.http.get(url, { responseType: 'text' }).subscribe((response: any) => {
      if (response) {
        console.log("Redirecting to:", response);
        window.location.href = response;
      }
    });

  }

  private handleIdactorLogin() {
    // Implement Idactor login logic here
    console.log("Logging in with Idactor");
  }

  getExternalGuestProfile(loginProvider: externalLoginProvider, externalId: string, emailAddress: string): Observable<any> {

    let endpoint = this.settings.getEndpoint();
    if (!endpoint) {
      return of(false);
    }
    
    let systemCode: string;
    switch(loginProvider) {
      case externalLoginProvider.SFC:
        systemCode = "SfcCrm";
        break;
      case externalLoginProvider.IDACTOR:
        systemCode = "Idactor";
        break;
    }
    ///api/integrations/guestprofiles?systemCode=SfcCrm&externalId=195788-0&emailAddress=tero.raitanen@vitecsoftware.com
    const url = `${endpoint}/integrations/guestprofiles?systemCode=${systemCode}&externalId=${externalId}&emailAddress=${emailAddress}`;
    return this.http.get(url);

  }

  logout() {
    // Clear any stored session data related to external login
    this.storageService.removeSessionStorage('extLogin');
    this.router.navigate(['/availability']);
  }

}
